import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../redux/store";

interface User {
  userId: string;
  email: string;
  role: string;
  roleId: string;
  token: string;
  FirstName?: string;
  RoleNames: string[]; 
}

const initialState: User = {
    userId: '',
    email: '',
    role: '',
    roleId: '',
    token: '',
    FirstName: '',
    RoleNames: [], 
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        updateUser: (state, action: PayloadAction<User>) => {
            state.email = action.payload.email;
            state.role = action.payload.role;
            state.userId = action.payload.userId;
            state.roleId = action.payload.roleId;
            state.token = action.payload.token;
            state.FirstName = action.payload.FirstName;
            state.RoleNames = action.payload.RoleNames ?? []; // ✅ now saved to store
        },
        signOut: (state) => {
            state.email = '';
            state.role = '';
            state.userId = '';
            state.roleId = '';
            state.token = '';
            state.FirstName = '';
            state.RoleNames = []; // ✅ cleared on logout
        }
    }
});

export const { updateUser, signOut } = userSlice.actions;
export default userSlice.reducer;